<template>
    <div class='content'> 
      <div class='top'>
        <img src='@assets/img/document/top_left.png' >
        <div class='top_right'> 
            <div class='title'>开放服务</div>
            <div class='dero'>我们提供机票、火车票、打车、酒店、保险等综合航旅商务专属服务</div>
            <div class='document_cont'>
              <div class='document_item' v-for='(item,index) in business' :key='index' @click='toDocument(index)'>
                <div class='circle'>
                  <img :src='require("@assets/img/document/c" + (index + 1 )+ ".png")' >
                </div>
                <div class='item_title'>{{item.title}}</div>
                <div class='item_dero'>{{item.dero}}</div>
              </div>
              
            </div>
        </div>
      </div>

      <div class='middle'>
        <div class='title'>技术能力</div>
        <div class='middle_content'>
          <div class='middle_item' v-for='(item,index) in marr' :key='index'>
            <img :src='require("@assets/img/document/m" + (index + 1 )+ ".png")'>
            <div class='item_right'>
              <div class='item_title'>{{item.title}}</div>
              <div class='item_dero'>{{item.dero}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class='bottom'>
        <div class='title'>接入流程</div>
        <div class='bottom_content'>
          <div class='bottom_item' v-for='(item,index) in barr' :key='index'> 
            <div class='bottom_title'>{{item.title}}</div>
            <div class='bottom_dero'>{{item.dero}}</div>
            <div class='bottom_num'>0{{index + 1}}</div>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
import { ref, watch ,computed } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
export default {
  name: 'document',
  components: {

  },
  setup () {
    // http://doc.1-trip.com/

    let business = [
      {
        title : '火车票',
        dero : '极速抢票、优先定座'
      },
      {
        title : '机票',
        dero : 'VIP通道、专属客服'
      },
      {
        title : '打车',
        dero : '专车接送、至尊享受'
      },
      {
        title : '酒店',
        dero : '到店支付、免费升级'
      }
    ]

    let marr = [
      {
        title : 'H5移动端',
        dero : '可以通过手机浏览器微信多端接入'
      },
      {
        title : 'APi接入',
        dero : '用API来满足您的业务和系统需求来'
      },
      {
        title : 'WEB端',
        dero : '办公场景随时为你服务'
      },
      {
        title : '数据推送',
        dero : '您的数据你最懂,我们随时为你提供'
      }
    ]

    let barr = [
      {
        title : '联系商务',
        dero : '确保您得到专属的服务和相应请联系我们的商务'
      },
      {
        title : '开通账号',
        dero : '和您建立合作后会为您开通账号并提供专业的培训'
      },
      {
        title : '开发测试',
        dero : '我们将会提供专属工程师为您提供专属的测试环境'
      },
      {
        title : '发布上线',
        dero : '完成开发后您我们将为你开通正式服务'
      }
    ]

    const toDocument = (index) => {
      if(!index){
        window.open('http://doc.tianxiapiao.cn/open-trains-api/')
      }else{
        message.info('暂未开放')
      }
    }

    return {
      toDocument,
      barr,
      marr,
      business,
    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .content{
      width: 1200px;
      margin: 0 auto;
      padding-top: 70px;
  
      .top_right{
        width: 421px;

      }
      .top{
        display: flex;
        justify-content: space-between;
        min-height: 685px;
        &>img{
          width: 683px;
          height: 685px;
        }
      }

      .title{
        font-size: 25px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
      }
      .dero{
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-top: 10px;
        margin-bottom: 100px;
      }
    }
    .document_cont{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .document_item{
        width: 192px;
        height: 130px;
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        margin-bottom: 80px;
        cursor: pointer;
        position: relative;
        .circle{
          width: 62px;
          height: 62px;
          border-radius:50%;
          position: absolute;
          top:-31px;
          left:50%;
          margin-left: -31px;
          background-color: #FD5739; 
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 28px;
          }
        }
        .item_title{
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          text-align: center;
          margin-top: 37px;
          line-height: 28px;
        }
        .item_dero{

          line-height: 22px;
          margin-top: 13px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6D7278;
          text-align: center;
        }
      }
    }
    .middle{
      .title{
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 56px;
        text-align: center;
      }
      .middle_content{
        display: flex;
        justify-content: space-between;
        margin-top: 42px;
        .middle_item{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img{
            width: 75px;
            height: auto!important;
          }
          .item_right{
            margin-left: 20px;
          }
          .item_title{
            font-size: 25px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
          }
          .item_dero{
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #6D7278;
            max-width: 150px;
          }

        }
      }

    }

    .bottom{
      margin-top: 120px;
      margin-bottom: 400px;
      .title{
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 56px;
        text-align: center;
      }
      .bottom_content{
        margin-top: 70px;
        display: flex;
        justify-content: space-between;
        .bottom_item{
          position: relative;
          .bottom_num{
            position: absolute;
            width: 88px;
            height: 100px;
            font-size: 60px;
            font-family: Arial-Black, Arial;
            font-weight: 900;
            color: #6D7278;
            line-height: 100px;
            letter-spacing: 3px;
            background: linear-gradient(181deg, #FD5739 0%, #FFFFFF 100%, #FFFFFF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            bottom:-100px;
            left: 50%;
            margin-left: -44px;
            opacity: 0.3;
          }
          .bottom_title{
            font-size: 25px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 36px;
            color: #000000;
          }
          .bottom_dero{
            margin-top: 5px;
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #6D7278;
            max-width: 240px;
          }
        }
      }
    }


</style>
